import { HorizontalContainer, IconButton, Tooltip } from '@/components';
import { CloseIcon, MaximizeIcon } from '@/components/Icons';
import { cn } from '@/lib/cn';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type MinimizedDrawerProps = {
    minimized: boolean;
    title: string;
    subtitle?: string;
    onMaximize: () => void;
    onClose: () => void;
};

export const MinimizedDrawer = ({
    minimized,
    title,
    subtitle,
    onMaximize,
    onClose,
}: MinimizedDrawerProps) => {
    return (
        <div
            className={cn('inset-0 z-50', {
                hidden: !minimized,
            })}
        >
            <HorizontalContainer
                className="absolute bottom-0 w-full items-center justify-between border-b border-(--color-border-muted) bg-(--color-bg-canvas) px-10 py-6 shadow-[0_0_10px_2px_rgba(0,0,0,0.25)] lg:w-3/4"
                spacing="md"
            >
                <HorizontalContainer className="items-center">
                    <h4>{title}</h4>
                    {subtitle && <span>{subtitle}</span>}
                </HorizontalContainer>
                <HorizontalContainer>
                    <IconButton
                        tooltip={R.Maximize}
                        tooltipDirection="top"
                        onClick={onMaximize}
                        icon={<MaximizeIcon variant="action" />}
                    />

                    <IconButton
                        tooltip={R.Close}
                        tooltipDirection="top"
                        onClick={onClose}
                        icon={<CloseIcon variant="action" />}
                    />
                </HorizontalContainer>
            </HorizontalContainer>
        </div>
    );
};
